<!--
 * @Author: your name
 * @Date: 2021-04-01 16:18:32
 * @LastEditTime: 2021-08-30 18:43:52
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/components/AddressInput/index.vue
-->
<style scoped lang="sass">
.delivery_loading
  position: fixed
  top: 0
  right: 0
  bottom: 0
  left: 0
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
  background-color: #fff
  opacity: .85
  z-index: 9999

  .delivery_loading_text
    margin-bottom: 10px
    font-size: 20px
    font-weight: bold
    color: #000

</style>

<template lang="pug">
  .delivery_loading
    .delivery_loading_text Please wait…
    van-loading(:color="color" size="66")
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
@Component({
  computed: {
    color() {
      return this.$store.state.app.color.menu_primary_background_colour
    },
  }
})

class Loading extends Vue {
}

export default Loading
</script>